// =============================================================================
// FRAMER MOTION ANIMATION VARIANTS
// =============================================================================

import { Variants } from 'framer-motion';

/**
 * Fade in from bottom - для появи карток
 */
export const fadeInUp: Variants = {
  hidden: {
    opacity: 0,
    y: 20,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 1.2,
      ease: [0.25, 0.46, 0.45, 0.94],
    },
  },
  exit: {
    opacity: 0,
    y: -20,
    transition: {
      duration: 0.3,
    },
  },
};

/**
 * Scale in - для кнопок та елементів
 */
export const scaleIn: Variants = {
  hidden: {
    opacity: 0,
    scale: 0.9,
  },
  visible: {
    opacity: 1,
    scale: 1,
    transition: {
      duration: 1.2,
      ease: 'easeOut',
    },
  },
};

/**
 * Stagger children - для списків опцій
 */
export const staggerContainer: Variants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.3,
      delayChildren: 0.2,
    },
  },
};

/**
 * Slide in from left - для бріфінгу
 */
export const slideInLeft: Variants = {
  hidden: {
    opacity: 0,
    x: -50,
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.5,
      ease: 'easeOut',
    },
  },
};

/**
 * Pulse animation - для URGENT елементів
 */
export const pulseAnimation: Variants = {
  pulse: {
    scale: [1, 1.02, 1],
    boxShadow: [
      '0 0 0 0 rgba(220, 38, 38, 0)',
      '0 0 0 8px rgba(220, 38, 38, 0.3)',
      '0 0 0 0 rgba(220, 38, 38, 0)',
    ],
    transition: {
      duration: 2,
      repeat: Infinity,
      ease: 'easeInOut',
    },
  },
};

/**
 * Progress bar fill animation
 */
export const progressFill: Variants = {
  hidden: { width: '0%' },
  visible: (custom: number) => ({
    width: `${Math.max(0, Math.min(100, custom))}%`,
    transition: {
      duration: 0.8,
      ease: 'easeOut',
    },
  }),
};

/**
 * Hover effect для карток рішень
 */
export const cardHover = {
  rest: {
    scale: 1,
    boxShadow: '0 0 0 1px rgba(148, 163, 184, 0.1)',
  },
  hover: {
    scale: 1.02,
    boxShadow:
      '0 0 26px 0 rgba(59, 130, 246, 0.16), 0 0 22px 0 rgba(245, 158, 11, 0.12), 0 0 28px 0 rgba(220, 38, 38, 0.10), 0 0 0 1px rgba(148, 163, 184, 0.18)',
    transition: {
      duration: 0.2,
    },
  },
  tap: {
    scale: 0.98,
  },
};

/**
 * Page transition
 */
export const pageTransition: Variants = {
  initial: {
    opacity: 0,
  },
  animate: {
    opacity: 1,
    transition: {
      duration: 0.5,
    },
  },
  exit: {
    opacity: 0,
    transition: {
      duration: 0.3,
    },
  },
};

/**
 * Typewriter effect для тексту
 * Використовується з CSS animation, не Framer
 */
export const typewriterConfig = {
  speed: 20, // ms per character
  startDelay: 300, // ms before starting
};

/**
 * Number counter animation config
 */
export const counterAnimation = {
  duration: 0.8,
  ease: 'easeOut',
};
